import { Module } from 'vuex'
import { JobChatState } from './types'
import { getApplication } from '@/api/jobs/applications/applications'
import JobApplication from '@/models-ts/job/JobApplication'
import LoadableModel from '@/models-ts/LoadableModel'
import { RootState } from '@/store'

const getInitialState = (): JobChatState => ({
  application: new LoadableModel(),
  archiving: false,
  decliningOffer: null,
  acceptingOffer: null,
  depositingOffer: null,
})

export default (): Module<JobChatState, RootState> => ({
  namespaced: true,
  state: getInitialState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitialState())
    },
    setLoading(state) {
      state.application.loading()
    },
    setLoaded(state, application: JobApplication) {
      state.application.loaded(application)
    },
    setArchiving(state, flag: boolean) {
      state.archiving = flag
    },
    setDepositingOffer(state, id: number | null) {
      state.depositingOffer = id
    },
    setAcceptingOffer(state, id: number | null) {
      state.acceptingOffer = id
    },
    setDecliningOffer(state, id: number | null) {
      state.decliningOffer = id
    },
    updateApplication(state, { id, ...fields }: { id: JobApplication['id'] } & Partial<JobApplication>) {
      if (state.application.value?.id !== id) return

      Object.assign(state.application.value, fields)
    },
    setJobIsDone(state, { id, isDone }: { id: JobApplication['id']; isDone: boolean }) {
      if (state.application.value?.id !== id) return

      state.application.value.job.isDone = isDone
    },
  },
  actions: {
    async getApplication({ commit }, applicationId: number) {
      commit('setLoading')
      const application = await getApplication(applicationId)
      commit('setLoaded', JobApplication.fromServer(application))
    },
    async updateArchiveApplicationFlag({ commit, dispatch, state }, { applicationId, flag }: { applicationId: number; flag: boolean }) {
      const application = state.application.value
      if (application?.id !== applicationId) return
      if (state.archiving) return

      commit('setArchiving', true)
      try {
        const meta = { ...application.meta, archived: flag }
        await dispatch(
          'jobDetails/setApplicationMeta',
          {
            jobId: application.job.id,
            applicationId: application.id,
            meta,
          },
          { root: true }
        )
        commit('updateApplication', { id: applicationId, meta })
      } finally {
        commit('setArchiving', false)
      }
    },
  },
})
